import React, {
  InputHTMLAttributes,
  useCallback,
  useState,
  FocusEvent,
} from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { Field, ErrorMessage } from 'formik';
import { IconBaseProps } from 'react-icons/lib';
import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  thickness?: string;
  icon?: React.ComponentType<IconBaseProps>;
  noMargin?: boolean;
}

export const Input: React.FC<InputProps> = ({
  name,
  icon: Icon,
  thickness,
  noMargin,
  type,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const handlePasswordVisible = () => {
    setPasswordVisible(old => !old);
  };

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setIsFilled(!!e.target.value);
    setIsFocused(false);
  }, []);

  return (
    <Container
      isFocused={isFocused}
      isFilled={isFilled}
      textarea={type === 'textarea'}
      thickness={thickness}
      noMargin={noMargin}
    >
      <div>
        {Icon && <Icon size={20} id="input-icon" />}
        <Field
          id={name}
          name={name}
          as={type === 'textarea' ? 'textarea' : 'input'}
          {...rest}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          type={type === 'password' && passwordVisible ? 'text' : type}
        />

        {type === 'password' && (
          <button type="button" onClick={handlePasswordVisible}>
            {passwordVisible ? <FiEye /> : <FiEyeOff />}
          </button>
        )}
      </div>

      <ErrorMessage name={name} render={msg => <Error>{msg}</Error>} />
    </Container>
  );
};
